import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function deleteResourceDocument(id: string) {
  return getSMPBackendAPIAdmin().resourceDocumentsControllerDeleteV1(id);
}

export function useDeleteResourceDocument() {
  return useMutation({ mutationFn: deleteResourceDocument });
}
